import * as NavConstants from 'constants/NavConstants';
import {AgentType} from 'graphql-client/__generated/graphqlGlobalTypes';
import {ChatDraftStatus, createChatWithDraftMessage} from 'llm/chat-library/ChatActions';
import {openExistingChat} from 'llm/chat-library/sidepanel/AISidepanelV2GlobalClientState';
import {getChatTypeForNewAgentChat} from 'llm/chat-library/sidepanel/ChatTypeUtil';
import * as SidepanelActions from 'nav/sidepanel/SidepanelActions';

import {PlotSuggestion} from './SuggestPlotsConstants';

async function submitPromptToNewChat({
  prompt,
  entryId,
}: {
  prompt: string;
  entryId: string | null;
}): Promise<string> {
  const agentType = AgentType.ASSISTANT;
  const chatType = getChatTypeForNewAgentChat(agentType);
  const contextIds = entryId ? [entryId] : [];

  const {chatSessionId} = await createChatWithDraftMessage(chatType, {
    createParams: {contextIds},
    draft: {
      status: ChatDraftStatus.DRAFT,
      message: {text: prompt, selectedFiles: []},
      settings: {agentType, publicDataEnabled: false},
    },
  });

  openExistingChat(chatSessionId);
  SidepanelActions.openSection(NavConstants.SECTIONS.AI);

  return chatSessionId;
}

export function openCustomPlotDraftInChat({
  tableName,
  entryId,
}: {
  tableName: string;
  entryId: string | null;
}): Promise<string | null> {
  const prompt = `I want to create a chart for the data in table "${tableName}". Please ask me one or two questions to determine what the desired plot should contain then create the appropriate chart.`;
  return submitPromptToNewChat({prompt, entryId});
}

export function buildPromptFromSuggestion({
  suggestion,
  tableName,
}: {
  suggestion: PlotSuggestion;
  tableName: string;
}): string {
  const axisParts: Array<string> = [];
  if (suggestion.xAxis) {
    axisParts.push(`x-axis: ${suggestion.xAxis}`);
  }
  if (suggestion.yAxis) {
    axisParts.push(`y-axis: ${suggestion.yAxis}`);
  }
  const axisClause = axisParts.length > 0 ? ` with ${axisParts.join(' and ')}` : '';

  return `Please create a ${suggestion.chartType} chart titled "${suggestion.title}" using data from the table "${tableName}"${axisClause}. ${suggestion.description}`;
}

export function runSuggestPlotPromptInChat({
  suggestion,
  tableName,
  entryId,
}: {
  suggestion: PlotSuggestion;
  tableName: string;
  entryId: string | null;
}): Promise<string | null> {
  const prompt = buildPromptFromSuggestion({suggestion, tableName});
  return submitPromptToNewChat({prompt, entryId});
}
